module.exports = __webpack_public_path__ + "9312c6b69eb6aa235f1ddfc11ed98ec6.woff2";